import { BlogSection } from "@/types/blog";

export const sinn: BlogSection = {
  id: "sinn-und-orientierung",
  title: "Sinn und Orientierung geben",
  content: `
    <p>Menschen möchten verstehen, wofür sie ihre Energie einsetzen.</p>

    <p>Führung heißt hier, Zusammenhänge sichtbar zu machen.</p>

    <blockquote>
      <p><em>Warum tun wir das?</em></p>
      <p><em>Wem hilft es?</em></p>
      <p><em>Was verändert sich dadurch?</em></p>
    </blockquote>

    <p>Wenn Antworten greifbar werden, entsteht Motivation von innen statt Druck von außen.</p>

    <p>Die Selbstbestimmungstheorie beschreibt Sinn als einen grundlegenden psychologischen Bedarf.</p>
  `
};
